import { ObservableArray, View } from "binder"
import { Menu, MenuImageManipulationViewModel } from "./menuImageManipulation-viewModel"

export class MenuImageManipulationView extends View<MenuImageManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-932A3607-2FE7-4480-A3FE-1F7E5AC6D88C"
        return "V-C5540052-17B4-49CE-9B15-034D3C421B98"
    }
    loadHtml(): string {
        let element = require('./menuImageManipulation.html').default;
        let style = require('./menuImageManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set root(v: Menu) { this._root = v; } public get root(): Menu { return this._root;} private _root: Menu;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set rootList(v: ObservableArray<Menu>) { this._rootList = v; } public get rootList(): ObservableArray<Menu> { return this._rootList;} private _rootList: ObservableArray<Menu>;
    
    refresh(){
        this.dataContext.refresh();
    }

    save(){
        this.dataContext.save();
    }
}
